// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toCorrectFormDataValue(value) {
    // isFile
    if ('lastModified' in value) {
        return value;
    }
    return value.toString();
}
